import { HeadshotPlanTermCode } from '@minecraft.graphql-operations';

/** Heap filter values for "Talent - Click - Nav - Headshots". */
export const HEADSHOT_NAV_MEMBERSHIP = {
  ACTIVE_TRIAL: 'Active Trial',
  MONTHLY: 'Monthly',
  ANNUAL: 'Annual',
} as const;

export type HeadshotNavMembership = typeof HEADSHOT_NAV_MEMBERSHIP[keyof typeof HEADSHOT_NAV_MEMBERSHIP];

/**
 * Membership segment attached to the Headshots nav click.
 * An active paid trial wins over plan term, because those subscribers are still
 * on an annual or monthly plan. Free and Essential subscribers are omitted so
 * they are not counted in the Monthly or Annual filters.
 */
export const getHeadshotNavMembership = ({
  isFreeHeadshotsSubscriber,
  isPaidTrialSubscriber,
  planTermCode,
}: {
  isFreeHeadshotsSubscriber: boolean;
  isPaidTrialSubscriber: boolean;
  planTermCode?: HeadshotPlanTermCode | null;
}): HeadshotNavMembership | undefined => {
  if (isPaidTrialSubscriber) {
    return HEADSHOT_NAV_MEMBERSHIP.ACTIVE_TRIAL;
  }

  if (isFreeHeadshotsSubscriber) {
    return undefined;
  }

  if (planTermCode === HeadshotPlanTermCode.Monthly) {
    return HEADSHOT_NAV_MEMBERSHIP.MONTHLY;
  }

  if (planTermCode === HeadshotPlanTermCode.Annual) {
    return HEADSHOT_NAV_MEMBERSHIP.ANNUAL;
  }

  return undefined;
};
